import { render, staticRenderFns } from "./CommitteesRearrange.vue?vue&type=template&id=030906f5"
import script from "./CommitteesRearrange.vue?vue&type=script&lang=js"
export * from "./CommitteesRearrange.vue?vue&type=script&lang=js"
import style0 from "./CommitteesRearrange.vue?vue&type=style&index=0&id=030906f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports